











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { Route } from "vue-router";

@Component
export default class ModalCard extends Vue {
  @Prop({ default: "" })
  public title!: string;

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public hasPaddinglessBody!: boolean;

  @Prop({ default: "_action.cancel" })
  public cancelText!: string | TranslateResult;

  @Prop({ default: true })
  public showFooter!: boolean;

  @Prop({ required: false, default: false })
  public blockCancellation!: boolean;

  @Prop({ default: true })
  public autoCloseOnRouteChange!: boolean;

  @Watch("blockCancellation", { immediate: true })
  public onBlockCancellation(newVal) {
    if (
      this.$_.isFunction(this.$_.get(this, "parentModal.setBlockCancellation"))
    ) {
      this.parentModal.setBlockCancellation(newVal);
    }
  }

  // Computed

  public get cancelLabel() {
    return (this.cancelText as string).match(/^_\w*\.[\w.]+$/g)
      ? this.$t(this.cancelText as string)
      : this.cancelText;
  }

  public get canCancelByButton() {
    const cancelOptions = this.parentModal.cancelOptions;
    return cancelOptions && cancelOptions.includes("button");
  }

  public get canCancelByX() {
    const cancelOptions = this.parentModal.cancelOptions;
    return cancelOptions && cancelOptions.includes("x");
  }

  public get parentModal() {
    const parent = this.getParentModal(this);
    return parent || this;
  }

  public get isSlide() {
    return this.parentModal && this.parentModal.__SLIDE__;
  }

  // Life-cycle methods

  public created() {
    const el: any = document.querySelector(":focus");
    if (el) {
      el.blur();
    }
  }

  public mounted() {
    this.$bus.$on(`route-path-changed`, this.onRouteChange);
  }

  public beforeDestroy() {
    this.$bus.$off(`route-path-changed`, this.onRouteChange);
  }

  // Methods

  public onRouteChange(change: { to: Route; from: Route }) {
    this.$emit("route-change", change);
    if (this.autoCloseOnRouteChange) this.$emit("close");
  }

  public getParentModal(vue) {
    if (!vue.$parent) return vue;
    return ["BModal"].includes(this.$_.get(vue, "constructor.options.name")) ||
      vue.__SLIDE__
      ? vue
      : this.getParentModal(vue.$parent);
  }
}
